import { defineStore } from 'pinia'
import {computed, ref} from 'vue'

export const useFilterStore = defineStore('filter', () =>
{
    let searchTerm = ref('')
    let filters = ref({})
    let selectedFilters = ref({})
    let rangeFilters = ref({})

    const selectedFiltersFilled = computed(() =>
    {
        if (selectedFilters.value) {
            for (const [key] of Object.entries(selectedFilters.value))
            {
                if (selectedFilters.value[key].length)
                {
                   return true
                }
            }
        }
        if (rangeFilters.value)
        {
            for (const [key] of Object.entries(rangeFilters.value))
            {

                if (rangeFilters.value[key].options[0].min && rangeFilters.value[key].options[0].min === rangeFilters.value[key].options[1].max)
                {
                    return true
                }
            }
        }
        return false
    })

    function prepareSelectedFilter ()
    {
        if (filters.value) {
            for (const [key] of Object.entries(filters.value))
            {
                if (key !== 'cableDiameterRange')
                {
                    selectedFilters.value[key] = []
                }
                else
                {
                    rangeFilters.value[key] = filters.value[key]
                }

            }
        }
    }

    function updateRangeFilter ()
    {
      if (filters.value) {
        if (rangeFilters.value)
        {
          for (const [key] of Object.entries(rangeFilters.value))
          {
            if (rangeFilters.value[key].options[0].min !== rangeFilters.value[key].options[1].max)
            {
              for (const [key2] of Object.entries(filters.value))
              {
                if (key2 === 'cableDiameterRange')
                {
                  rangeFilters.value[key2] = filters.value[key2]
                }

              }
            }
          }
        }

      }
    }

    function clearSelectedFilters () {
        prepareSelectedFilter()
    }

    return {
        searchTerm,
        selectedFilters,
        rangeFilters,
        filters,
        clearSelectedFilters,
        selectedFiltersFilled,
        prepareSelectedFilter,
        updateRangeFilter
    }})
